import { Injectable } from '@angular/core';
import { BaseController } from '@app/common/modules/base/base.controller';
import { AlterarKmRepository } from '@app/data/alterar-km/alterar-km.repository';
import { AlterarKmModel } from '@app/data/alterar-km/models';

@Injectable()
export class AlterarKmController extends BaseController<AlterarKmModel> {
  constructor(alterarKmRepository: AlterarKmRepository) {
    super(alterarKmRepository);
  }
}
